<template>
    <div>
        <b-modal no-stacking
            v-model="orders.isShow"
            centered
            no-close-on-esc
            no-close-on-backdrop
            hide-footer
            size="lg"
            @close="closeMe()"
        >
            <template slot="modal-title">
                <div slot="header" class="bg-white border-0">
                    <div class="row align-items-center">
                        <div class="col-12">
                            <h3 class="mb-0">ข้อมูลการจัดส่ง</h3>
                        </div>
                    </div>
                </div>
            </template>
            <div class="container-fluid pb-5">
                <div class="row mb-3">
                    <div class="col-12 d-flex justify-content-between">
                        <h4>ที่อยู่ปลายทาง <small class="text-muted">( {{orders.order.length}}/ชิ้น )</small></h4>
                        <b-button variant="primary" 
                            v-if="!checkThemeQuick()"
                            size="sm" 
                            @click="addOrders()" >
                            เพิ่มที่อยู่ปลายทาง
                        </b-button>
                    </div>
                </div>
                <div class="scroll-table scroll-bar-pop scrollbar-style table-responsive">
                <table class="table">
                    <thead>
                        <tr class="text-center">
                            <th>#</th>
                            <th>ชื่อผู้รับ</th>
                            <th>เบอร์โทร</th>
                            <th>ที่อยู่</th>
                            <th>ขนาดพัสดุ</th>
                            <th>น้ำหนัก</th>
                            <th>ค่าจัดส่ง</th>
                            <th>ยอด COD</th>
                            <th>ค่าบริการพิ้นที่พิเศษ</th>
                            <th>ค่าประกันสินค้า</th>
                            <th>จัดการ</th>
                        </tr>
                    </thead>
                    <tbody class="table-tbody">
                        <template v-for="( order , index ) in orderSortError">
                            <tr :key="index" :class="[ 
                                  'text-center' , 
                                  {
                                      'tr-error-after-create-order-details'
                                      : hasError(order).status
                                  } 
                                ]">
                                <!-- hasError(order).rowspan -->
                                <td :rowspan="hasError(order).rowspan">{{index+1}}</td>
                                <td>{{order.to.name}}</td>
                                <td>{{order.to.tel}}</td>
                                <td>{{order.to.address +' '+ order.to.state +' '+ order.to.district +' '+ order.to.province +' '+ order.to.postcode}} </td>
                                <template v-if="(+order.parcel.width) + (+order.parcel.length) + (+order.parcel.height) > 3">
                                    <td>
                                        {{
                                            (order.parcel.width > 0 ? order.parcel.width : 0) 
                                            +'x'+ 
                                            (order.parcel.length > 0 ? order.parcel.length : 0) +'x'+ 
                                            (order.parcel.height > 0 ? order.parcel.height : 0)
                                        }}
                                    </td>
                                </template>
                                <template v-else>
                                    <td>-</td>
                                </template>
                                <td>{{ ( $THEME.unitKG ) ? order.parcel.weightKG+' kg' : order.parcel.weight+' g'}}</td>
                                <td>{{order.price}}</td>
                                <td>{{order.cod_amount > 0 ? order.cod_amount : '-'}}</td>
                                <td>{{
                                    order.rate_remote_area > 0 
                                    ? order.rate_remote_area 
                                    : '-'
                                }}</td>
                                <td>{{order.insurance.listPrice.price}}</td>
                                <td>
                                    <div class="d-flex">
                                    <button
                                      class="btn btn-link text-info p-2 hvr-grow"
                                      @click="handleVisible() , func.editOrder( [order] )"
                                    >
                                      <i class="fas fa-edit"></i>
                                    </button>
                                    <button
                                      class="btn btn-link text-danger p-2 hvr-grow"
                                      @click="removeOrder( order.check )"
                                    >
                                      <i class="far fa-trash-alt"></i>
                                    </button>
                                  </div>
                                </td>
                            </tr>
                            <tr :key="`error-msg-${index}`"
                                v-if="hasError(order).status"
                                class="text-center tr-error-after-create-order-msg">
                                <td colspan="10">
                                  {{'กรุณากรอกข้อมูลให้ถูกต้อง'}}
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
                </div>
            </div>
            <div class="text-center m-4">
                <b-button variant="secondary" @click="closeMe()">ยกเลิกรายการ</b-button>
                <b-button 
                    variant="primary"
                    :disabled="disableConfirm"
                    @click="func.confirmOrder()" >
                    ยืนยันข้อมูล
                </b-button>
            </div>
        </b-modal>
    </div>
</template>
<script>

export default {
    name: 'TableAddOrders' ,
    props:{
        orders: Object , 
        func: Object
    },
    data(){
        return {
            a: true,
        }
    },
    methods:{
        closeMe(){
            this.orders.isActive = false
            this.orders.order = []
            this.handleVisible()
            this.func.closeModal()
        },
        handleVisible(){
            this.orders.isShow = !this.orders.isShow
        },
        addOrders(){
            this.handleVisible()
            this.func.createOrder( this.orders.typeCourier )
        },
        removeOrder( check ){
            let order = this.orders.order
            order.splice(order.findIndex(item => item.check == check), 1)
        },
        hasError( order ){
            let res = {
                status: false,
                rowspan: ''
            }
            if(order.error.status === false)return res
            res.status = true
            res.rowspan = 2
            return res
        },
        checkThemeQuick(){
            return this.$THEME.name == 'quickexpress';
        },
    },
    computed:{
        checkError(){
            if( this.contOrder < 1 ) return false
            const _orders = this.orders.order
            return !_orders.every(( order ) => {
                return order.error.status === false
            })
        },
        contOrder(){
            return this.orders.order.length
        },
        disableConfirm(){
            return this.contOrder < 1 || this.checkError
        },
        orderSortError(){
            return this.orders.order.sort((a, b) => {
                return b.error.status - a.error.status;
            })
        }
        
    }
}
</script>
<style scoped>
.table{
    background: #F2F2F2;
    border-radius: 8px 8px 0px 0px;
}
.table-tbody{
    background: #ffffff;
}
.tr-error-after-create-order-details{

    color:#fb6340;

  }

  .tr-error-after-create-order-msg{

    background: #ff00000f;
    color: #fb6340;
    font-weight: bold;

  }
</style>